module.exports = __webpack_public_path__ + "static/media/Calibre-Semibold.d8b85647.woff2";